import axios from '@/libs/api.request'
// 套餐信息
export const getAppScheduleInfo = data => {
  return axios.request({
    url: '/appointment/schedule/info',
    data,
    method: 'POST'
  })
}
// 学生预约 - 未完成的预约
export const getAppUnfinishList = data => {
  return axios.request({
    url: '/appointment/unfinish/list',
    data,
    method: 'POST'
  })
}
// 学生预约 - 已完成的预约/撤回的预约
export const getAppfinishList = data => {
  return axios.request({
    url: '/appointment/finish/list',
    data,
    method: 'POST'
  })
}
// 创建预约
export const getAppCreate = data => {
  return axios.request({
    url: '/appointment/create',
    data,
    method: 'POST'
  })
}
//  创建预约 -获取导师模块剩余时间
export const getAppRemainTime = data => {
  return axios.request({
    url: '/appointment/joint/remain/time',
    data,
    method: 'POST'
  })
}
// 学生预约 - 确认时间
export const subAppConfirm = data => {
  return axios.request({
    url: '/appointment/confirm',
    data,
    method: 'POST'
  })
}
// 获取学生预约信息
export const getAppDeatil = data => {
  return axios.request({
    url: '/appointment/detail',
    data,
    method: 'POST'
  })
}
// 获取历史记录
export const getAppTrackList = data => {
  return axios.request({
    url: '/appointment/track/list',
    data,
    method: 'POST'
  })
}
// 学生选择时区 - 转换时间
export const getAppTimeZone = data => {
  return axios.request({
    url: '/appointment/time/by/zone',
    data,
    method: 'POST'
  })
}
// 置换时间
export const subAppPermuteTime = data => {
  return axios.request({
    url: '/appointment/permute/time',
    data,
    method: 'POST'
  })
}
export const getCsScheduleModule = data => {
  return axios.request({
    url: '/appointment/cs/schedule/by/module',
    data,
    method: 'POST'
  })
}
// 获取未完成的预约 - 模拟面试
export const getAppInterviewUnfinishList = data => {
  return axios.request({
    url: '/appointment/interview/unfinish/list',
    data,
    method: 'POST'
  })
}
// 获取已完成的预约 - 模拟面试
export const getAppInterviewFinishList = data => {
  return axios.request({
    url: '/appointment/interview/finish/list',
    data,
    method: 'POST'
  })
}
// 转换时间
export const getAppTimeConvert = data => {
  return axios.request({
    url: '/appointment/time/convert',
    data,
    method: 'POST'
  })
}
// 获取剩余时间
export const getAppRecentlyResultTime = data => {
  return axios.request({
    url: '/appointment/recently/result/time',
    data,
    method: 'POST'
  })
}
// 视频结束
export const subAppVideoFinish = data => {
  return axios.request({
    url: '/appointment/video/finish',
    data,
    method: 'POST'
  })
}
// 获取zoom会议ID
export const getZoomMeetingId = (id, value) => {
  return axios.request({
    url: '/appointment/zoom/meeting/id',
    params: { id: id, value: value },
    method: 'GET'
  })
}
